
function maskCpf(value: string) {
    let valor = value.replace(/\D/g, "").substring(0, 11);

    valor = valor.replace(/(\d{3})(\d)/, "$1.$2");
    valor = valor.replace(/(\d{3})(\d)/, "$1.$2");
    valor = valor.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return valor;
}
function maskCnpj(value: string) {
    let valor = value.replace(/\D/g, "").substring(0, 14);
    valor = valor.replace(/^(\d{2})(\d)/, "$1.$2");
    valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    valor = valor.replace(/\.(\d{3})(\d)/, ".$1/$2");
    valor = valor.replace(/(\d{4})(\d)/, "$1-$2");
    return valor;
}
export function maskCnpjCpf(value: string) {
    var valor = value.replace(/\D/g, "");
    if (valor.length > 11) {
        return maskCnpj(value);
    } else if (valor.length <= 11) {
        return maskCpf(value);
    } else {
        return value
    }
}

export function maskPhone(value: string) {
    let nvalor;
    let numeros = value.substring(0, 15).replace(/\D/g, "");

    if (numeros.length <= 10) {
        nvalor = numeros.replace(/^(\d\d)(\d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
        nvalor = nvalor.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos

        value = nvalor;
    } else if (numeros.length >= 11) {
        nvalor = numeros.replace(/^(\d\d)(\d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
        nvalor = nvalor.replace(/(\d{5})(\d)/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos

        value = nvalor;
    }

    return value.substring(0, numeros.length === 11 ? 15 : 14);
}